import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addToTeacher } from '../../api/user';
import { TeacherForm } from '../../components';

const NewTeacher = () => {
    const { user } = useSelector((state) => ({ ...state }))
    const { token } = useParams()
    const [loading, setLoadng] = useState(true)
    // const [values, setValues] = useState()
    const history = useHistory()

    useEffect(() => {
        addToTeacher(user.token, token)
            .then(res => {
                setLoadng(false)
                history.push('/user/dashboard')
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "Some error please try again later")
                history.push('/')
            })
    }, [])

    return (
        loading ? <h1>loading</h1> : <TeacherForm user={user} />
    )
};

export default NewTeacher;